import { render, staticRenderFns } from "./notification-bar.vue?vue&type=template&id=4a8af2ee&scoped=true&"
import script from "./notification-bar.vue?vue&type=script&lang=js&"
export * from "./notification-bar.vue?vue&type=script&lang=js&"
import style0 from "./notification-bar.vue?vue&type=style&index=0&id=4a8af2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8af2ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VImg,VSystemBar})
